import { render, staticRenderFns } from "./InventoryTable.vue?vue&type=template&id=464fcd3e&scoped=true"
import script from "./InventoryTable.vue?vue&type=script&lang=js"
export * from "./InventoryTable.vue?vue&type=script&lang=js"
import style0 from "./InventoryTable.vue?vue&type=style&index=0&id=464fcd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464fcd3e",
  null
  
)

export default component.exports